// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-i_hg","catalogByServiceItem__title":"c-i_hh"};